const pages = {
  // ---- News listing ----
  "news.title": "La salle de presse de L+TV",
  "news.subtitle": "Dernières actualités du Cameroun et d'ailleurs",
  "news.searchPlaceholder": "Rechercher des actualités...",
  "news.latestStories": "Derniers articles",
  "news.readFullStory": "Lire l'article complet",
  "news.noArticles": "Aucun article ne correspond à vos critères.",
  "news.cat.all": "Toutes",
  "news.cat.breaking": "À la une",
  "news.cat.local": "Actualités locales",
  "news.cat.national": "Actualités nationales",
  "news.cat.international": "Actualités internationales",
  "news.cat.politics": "Politique",
  "news.cat.business": "Économie",
  "news.cat.technology": "Technologie",
  "news.cat.society": "Société",
  "news.cat.religion": "Religion",
  "news.cat.culture": "Culture",
  "news.cat.sports": "Sports",
  "news.cat.entertainment": "Divertissement",
  "news.cat.lifestyle": "Mode de vie",

  // ---- News article ----
  "article.notFound": "Article introuvable",
  "article.notFoundDesc": "L'article que vous recherchez n'existe pas.",
  "article.backToNews": "Retour aux actualités",
  "article.news": "Actualités",
  "article.share": "Partager cet article",
  "article.related": "Articles similaires",
  "article.stayTuned":
    "L+TV TÉLÉVISION continue de vous apporter les dernières mises à jour et une couverture approfondie de cette actualité. Restez connectés à nos diffusions en direct, nos émissions d'information et nos plateformes numériques pour des informations en temps réel. Notre engagement en faveur d'un journalisme professionnel garantit que chaque reportage est diffusé avec exactitude, intégrité et les normes éditoriales les plus élevées.",
  "article.moreStories":
    "Pour plus d'articles comme celui-ci, visitez notre salle de presse ou suivez L+TV sur nos réseaux sociaux. Nous apprécions vos commentaires et encourageons les téléspectateurs à partager leurs points de vue sur les sujets qui comptent le plus pour notre communauté.",

  // ---- Programs ----
  "programs.title": "Émissions de L+TV",
  "programs.subtitle": "Découvrez notre grille de programmes télévisés",
  "program.notFound": "Émission introuvable",
  "program.backToPrograms": "Retour aux émissions",
  "program.relatedVideos": "Vidéos associées",
  "program.programDetails": "Détails de l'émission",
  "program.category": "Catégorie",
  "program.department": "Département",
  "program.presenter": "Présentateur",
  "program.broadcastDays": "Jours de diffusion",
  "program.time": "Heure",
  "program.duration": "Durée",
  "program.views": "vues",

  // ---- Schedule ----
  "schedule.title": "Grille TV",
  "schedule.subtitle": "Guide électronique des programmes de L+TV TÉLÉVISION",
  "schedule.thisWeek": "Cette semaine",
  "schedule.onNow": "EN COURS",
  "schedule.live": "DIRECT",
  "schedule.comingSoon": "La grille pour {tab} sera bientôt disponible.",
  "schedule.today": "Aujourd'hui",
  "schedule.tomorrow": "Demain",

  // ---- About ----
  "about.title": "À propos de L+TV",
  "about.subtitle": "La Télévision qui Vous Connecte — Edea, Cameroun",
  "about.whoWeAre": "Qui nous sommes",
  "about.whoP1":
    "L+TV TÉLÉVISION est une chaîne de télévision et de médias numériques basée à Edea, au Cameroun. Nous nous engageons à fournir un contenu professionnel, informatif et percutant qui relie les communautés à travers le Cameroun et la diaspora africaine.",
  "about.whoP2":
    "Des actualités de dernière minute et de la télévision en direct aux programmes culturels, à la couverture sportive et au contenu communautaire, L+TV rapproche les téléspectateurs des histoires qui comptent le plus.",
  "about.whoP3":
    "Notre équipe de journalistes, producteurs et professionnels de la diffusion expérimentés travaille sans relâche pour garantir que chaque émission respecte les normes les plus élevées de qualité et d'intégrité éditoriale.",
  "about.ourVision": "Notre vision",
  "about.visionQuote": "Faire de L+TV une chaîne locale, professionnelle et percutante.",
  "about.ourMission": "Notre mission",
  "about.missionText":
    "L+TV TÉLÉVISION s'engage dans une diffusion professionnelle qui fournit un contenu informatif, renforce les liens communautaires et produit des programmes percutants. Nous croyons au pouvoir de la télévision pour éduquer, inspirer et unir les gens à travers le Cameroun et au-delà. Notre mission est de servir de source fiable d'actualités, de divertissement et de contenu culturel qui reflète les valeurs, les aspirations et la diversité de notre public.",
  "about.ourValues": "Nos valeurs",
  "about.ourDepartments": "Nos départements",
  "about.value.excellence": "Excellence",
  "about.value.excellenceDesc":
    "Nous visons l'excellence dans chaque diffusion, émission et contenu que nous produisons.",
  "about.value.professionalism": "Professionnalisme",
  "about.value.professionalismDesc":
    "Notre équipe opère selon les normes les plus élevées de conduite professionnelle et de qualité de diffusion.",
  "about.value.discipline": "Discipline",
  "about.value.disciplineDesc":
    "Nous maintenons une discipline éditoriale stricte, respectons les délais et offrons une qualité constante.",
  "about.value.integrity": "Intégrité",
  "about.value.integrityDesc":
    "La vérité et l'intégrité sont au cœur de nos normes journalistiques et de diffusion.",
  "about.value.community": "Communauté",
  "about.value.communityDesc":
    "Nous nous engageons à servir et à connecter les communautés du Cameroun.",
  "about.value.creativity": "Créativité",
  "about.value.creativityDesc":
    "Nous adoptons une narration créative et des approches innovantes de la production télévisuelle.",
  "about.value.responsible": "Diffusion responsable",
  "about.value.responsibleDesc":
    "Nous diffusons avec responsabilité, respect et considération pour notre public diversifié.",
  "about.dept.news": "Département de l'information",
  "about.dept.newsDesc":
    "Fournir une couverture précise, opportune et approfondie des actualités locales, nationales et internationales.",
  "about.dept.entertainment": "Département divertissement & culture",
  "about.dept.entertainmentDesc":
    "Produire des divertissements, de la musique, des programmes culturels et du contenu jeunesse engageants qui reflètent la diversité du Cameroun.",
  "about.dept.technical": "Département technique & diffusion",
  "about.dept.technicalDesc":
    "Gérer l'infrastructure technique, les diffusions en direct et les opérations de studio qui alimentent la programmation de L+TV.",
  "about.dept.photo": "Studio Photo",
  "about.dept.photoDesc":
    "Services de photographie professionnelle pour portraits, événements, shootings commerciaux et projets créatifs.",
  "about.dept.production": "Société de production",
  "about.dept.productionDesc":
    "Production vidéo et télévisuelle complète pour les clients, partenaires et besoins de programmation interne.",

  // ---- Contact ----
  "contact.title": "Contacter L+TV",
  "contact.subtitle": "Nous serions ravis de vous entendre. Contactez L+TV TÉLÉVISION.",
  "contact.info": "Coordonnées",
  "contact.email": "E-mail",
  "contact.phone": "Téléphone",
  "contact.location": "Localisation",
  "contact.follow": "Suivre L+TV",
  "contact.edea": "Edea, Cameroun",
  "contact.mapNote": "Intégration de carte disponible",
  "contact.sendTitle": "Envoyez-nous un message",
  "contact.sendDesc": "Remplissez le formulaire ci-dessous et nous vous répondrons dès que possible.",
  "contact.messageSent": "Message envoyé !",
  "contact.messageSentDesc": "Merci de contacter L+TV. Nous répondrons à votre demande prochainement.",
  "contact.fullName": "Nom complet",
  "contact.emailAddress": "Adresse e-mail",
  "contact.phoneNumber": "Numéro de téléphone",
  "contact.subject": "Objet",
  "contact.department": "Département",
  "contact.message": "Message",
  "contact.yourName": "Votre nom",
  "contact.yourEmail": "votre@email.com",
  "contact.subjectPlaceholder": "Objet de votre message",
  "contact.messagePlaceholder": "Votre message...",
  "contact.maxChars": "500 caractères maximum",
  "contact.send": "Envoyer le message",
  "contact.required": "Veuillez remplir tous les champs obligatoires.",
  "contact.invalidEmail": "Veuillez saisir une adresse e-mail valide.",
  "contact.error": "Une erreur est survenue lors de l'envoi de votre message. Veuillez réessayer.",
  "contact.dept.general": "Demandes générales",
  "contact.dept.newsroom": "Salle de presse",
  "contact.dept.advertising": "Publicité",
  "contact.dept.partnerships": "Partenariats",
  "contact.dept.technical": "Support technique",
  "contact.dept.careers": "Carrières",
  "contact.dept.programs": "Émissions",

  // ---- Adverts ----
  "adverts.title": "Annonces & publicités",
  "adverts.subtitle": "Campagnes sponsorisées, annonces spéciales et publicités à la une de L+TV et de nos partenaires.",
  "adverts.noAdverts": "Aucune publicité disponible pour le moment. Revenez bientôt.",
  "adverts.active": "Active",
  "adverts.learnMore": "En savoir plus",

  // ---- Entertainment ----
  "entertainment.title": "Divertissement & Culture",
  "entertainment.subtitle": "Talk-shows, musique, jeunesse, culture et histoires de la communauté",
  "entertainment.featuredPrograms": "Émissions à la une",
  "entertainment.latestVideos": "Dernières vidéos",
  "entertainment.culturalStories": "Histoires culturelles",

  // ---- Sports ----
  "sports.title": "Sports L+TV",
  "sports.subtitle": "Actualités sportives, comptes-rendus de matchs, interviews et couverture locale",
  "sports.programs": "Émissions sportives",
  "sports.news": "Actualités sportives",
  "sports.videos": "Vidéos sportives",
  "sports.newsComingSoon": "Les actualités sportives arrivent bientôt.",
  "sports.videosComingSoon": "Les vidéos sportives arrivent bientôt.",

  // ---- Religion ----
  "religion.title": "Religion & Communauté",
  "religion.subtitle": "Enseignement biblique, discussions religieuses et événements communautaires",
  "religion.intro":
    "L+TV TÉLÉVISION s'engage à soutenir la vie spirituelle et communautaire de nos téléspectateurs. Nos émissions religieuses et communautaires apportent un enseignement biblique, des discussions basées sur la foi et la couverture d'événements communautaires qui renforcent les liens à travers le Cameroun.",
  "religion.programs": "Émissions",

  // ---- Gallery ----
  "gallery.title": "Galerie L+TV",
  "gallery.subtitle": "Photos de nos émissions, événements, studio et communauté",
  "gallery.loading": "Chargement de la galerie…",
  "gallery.noAlbums": "Aucun album photo publié pour le moment.",
  "gallery.albums": "albums",
  "gallery.photos": "photos",
  "gallery.close": "Fermer",
  "gallery.noPhotos": "Aucune photo dans cet album pour le moment.",

  // ---- Production ----
  "production.title": "Société de production L+TV",
  "production.subtitle": "Services professionnels de production télévisuelle et vidéo",
  "production.intro":
    "La société de production L+TV offre des services de production de qualité professionnelle aux particuliers, entreprises, organisations et institutions. Grâce à un équipement de pointe et une équipe de production expérimentée, nous livrons un contenu répondant aux normes les plus élevées de la télévision et des médias numériques.",
  "production.servicesTitle": "Nos services de production",
  "production.ctaTitle": "Intéressé par nos services de production ?",
  "production.ctaDesc": "Contactez L+TV pour discuter de vos besoins de production et obtenir un devis.",
  "production.getInTouch": "Nous contacter",
  "production.svc.tv.title": "Production télévisuelle",
  "production.svc.tv.desc": "Production télévisuelle complète pour la diffusion et les plateformes numériques, y compris les événements en direct, les émissions en studio et les tournages à distance.",
  "production.svc.video.title": "Production vidéo",
  "production.svc.video.desc": "Production vidéo de haute qualité pour publicités, documentaires, vidéos d'entreprise et contenus promotionnels.",
  "production.svc.interviews.title": "Interviews",
  "production.svc.interviews.desc": "Production professionnelle d'interviews avec des producteurs, réalisateurs et équipes techniques expérimentés pour un contenu prêt à diffuser.",
  "production.svc.event.title": "Couverture d'événements",
  "production.svc.event.desc": "Couverture complète d'événements incluant configurations multi-caméras, diffusion en direct et post-production pour conférences, cérémonies et événements culturels.",
  "production.svc.commercial.title": "Production de publicités",
  "production.svc.commercial.desc": "Services créatifs de production publicitaire pour les marques et entreprises cherchant une narration visuelle percutante.",
  "production.svc.documentary.title": "Production de documentaires",
  "production.svc.documentary.desc": "Production approfondie de documentaires racontant des histoires captivantes sur les personnes, les communautés et les enjeux importants au Cameroun.",
  "production.svc.studio.title": "Production en studio",
  "production.svc.studio.desc": "Services professionnels de production en studio utilisant les installations de diffusion de L+TV avec un équipement moderne et une équipe expérimentée.",

  // ---- Photo Studio ----
  "studio.title": "Studio Photo L+TV",
  "studio.subtitle": "Services professionnels de photographie à Edea, Cameroun",
  "studio.intro":
    "Le Studio Photo L+TV offre des services de photographie professionnelle pour les particuliers, les familles, les entreprises et les événements. Notre studio est équipé d'un éclairage professionnel, de fonds et d'équipements photographiques pour des résultats visuels exceptionnels.",
  "studio.servicesTitle": "Nos services",
  "studio.portfolio": "Portfolio",
  "studio.ctaTitle": "Réserver une séance photo",
  "studio.ctaDesc": "Contactez L+TV pour planifier votre séance de photographie professionnelle.",
  "studio.contactUs": "Contactez-nous",
  "studio.svc.portrait.title": "Photographie de portrait",
  "studio.svc.portrait.desc": "Portraits professionnels, portraits de famille et séances individuelles dans notre studio entièrement équipé.",
  "studio.svc.event.title": "Photographie d'événements",
  "studio.svc.event.desc": "Couverture complète de mariages, cérémonies, événements d'entreprise et rassemblements communautaires.",
  "studio.svc.studio.title": "Photographie en studio",
  "studio.svc.studio.desc": "Séances en studio de haute qualité avec éclairage professionnel, fonds et équipements.",
  "studio.svc.commercial.title": "Photographie commerciale",
  "studio.svc.commercial.desc": "Photographie de produits, images promotionnelles et contenu visuel de marque pour les entreprises.",

  // ---- Careers ----
  "careers.title": "Carrières chez L+TV",
  "careers.subtitle": "Rejoignez l'équipe de L+TV TÉLÉVISION",
  "careers.intro":
    "L+TV TÉLÉVISION est toujours à la recherche de personnes talentueuses et passionnées pour rejoindre notre équipe. Si vous êtes dévoué à la diffusion professionnelle, au journalisme de qualité et à l'impact communautaire, nous voulons vous entendre.",
  "careers.openPositions": "Postes ouverts",
  "careers.requirements": "Exigences",
  "careers.responsibilities": "Responsabilités",
  "careers.deadline": "Date limite",
  "careers.applyNow": "Postuler maintenant",
  "careers.submitTitle": "Soumettre votre candidature",
  "careers.submitDesc": "Postulez à un poste chez L+TV en remplissant le formulaire ci-dessous.",
  "careers.submittedTitle": "Candidature soumise !",
  "careers.submittedDesc": "Merci de votre intérêt. Notre équipe RH examinera votre candidature et vous contactera.",
  "careers.fullName": "Nom complet",
  "careers.email": "E-mail",
  "careers.phone": "Téléphone",
  "careers.position": "Poste",
  "careers.selectPosition": "Sélectionnez un poste",
  "careers.other": "Autre / Candidature générale",
  "careers.coverLetter": "Lettre de motivation",
  "careers.coverPlaceholder": "Pourquoi souhaitez-vous rejoindre L+TV ?",
  "careers.cvUpload": "Téléchargement du CV / document",
  "careers.cvDrag": "Glissez-déposez votre CV ou cliquez pour parcourir",
  "careers.cvNote": "PDF, DOC, DOCX jusqu'à 5 Mo",
  "careers.submitApp": "Soumettre la candidature",

  // ---- Partners ----
  "partners.title": "Partenaires & Collaboration",
  "partners.subtitle": "Collaborer avec des organisations qui soutiennent les médias et les initiatives communautaires",
  "partners.intro":
    "L+TV collabore avec des organisations et des partenaires dont la coopération soutient les médias, la communauté et les initiatives à impact social. Nous croyons au pouvoir des partenariats pour créer un contenu significatif et impulser un changement positif à travers le Cameroun.",
  "partners.ctaTitle": "Devenir partenaire de L+TV",
  "partners.ctaDesc":
    "Si votre organisation partage notre engagement envers la communauté, les médias et l'impact social, nous serions ravis d'explorer des opportunités de partenariat. Contactez-nous pour discuter de la façon dont nous pouvons collaborer.",
  "partners.getInTouch": "Nous contacter",

  // ---- Legal ----
  "legal.privacy.title": "Politique de confidentialité",
  "legal.privacy.sec1": "1. Introduction",
  "legal.privacy.sec1p": "L+TV TÉLÉVISION respecte votre vie privée et s'engage à protéger vos informations personnelles. Cette politique de confidentialité explique comment nous collectons, utilisons et protégeons vos données lorsque vous utilisez notre site web et nos services.",
  "legal.privacy.sec2": "2. Informations que nous collectons",
  "legal.privacy.sec2p": "Nous pouvons collecter des informations personnelles telles que votre nom, votre adresse e-mail, votre numéro de téléphone et d'autres détails que vous fournissez lorsque vous nous contactez, vous abonnez à nos newsletters ou postulez à des postes.",
  "legal.privacy.sec3": "3. Comment nous utilisons vos informations",
  "legal.privacy.sec3p": "Nous utilisons vos informations pour fournir et améliorer nos services, répondre aux demandes, envoyer des newsletters, traiter les candidatures et respecter nos obligations légales.",
  "legal.privacy.sec4": "4. Sécurité des données",
  "legal.privacy.sec4p": "Nous mettons en œuvre des mesures de sécurité appropriées pour protéger vos informations personnelles contre tout accès, altération ou destruction non autorisés.",
  "legal.privacy.sec5": "5. Contactez-nous",
  "legal.privacy.sec5p": "Si vous avez des questions concernant cette politique de confidentialité, contactez-nous à L+TV TÉLÉVISION, B.P. : EDEA - Cameroun.",

  "legal.terms.title": "Conditions d'utilisation",
  "legal.terms.sec1": "1. Acceptation des conditions",
  "legal.terms.sec1p": "En accédant et en utilisant le site web de L+TV TÉLÉVISION, vous acceptez d'être lié par ces conditions d'utilisation. Si vous n'acceptez pas une partie de ces conditions, veuillez ne pas utiliser notre site web.",
  "legal.terms.sec2": "2. Utilisation du contenu",
  "legal.terms.sec2p": "Tout le contenu de ce site web, y compris les textes, images, vidéos et logos, est la propriété de L+TV TÉLÉVISION et est protégé par le droit d'auteur et d'autres lois sur la propriété intellectuelle. Vous ne pouvez pas reproduire, distribuer ou modifier un contenu sans autorisation écrite préalable.",
  "legal.terms.sec3": "3. Conduite de l'utilisateur",
  "legal.terms.sec3p": "Les utilisateurs acceptent d'utiliser le site web de manière licite et de ne pas se livrer à une activité susceptible de nuire au site web, à ses utilisateurs ou à L+TV TÉLÉVISION.",
  "legal.terms.sec4": "4. Limitation de responsabilité",
  "legal.terms.sec4p": "L+TV TÉLÉVISION n'est pas responsable des dommages résultant de l'utilisation ou de l'impossibilité d'utiliser ce site web ou son contenu.",
  "legal.terms.sec5": "5. Droit applicable",
  "legal.terms.sec5p": "Ces conditions sont régies par les lois de la République du Cameroun.",

  "legal.cookies.title": "Politique de cookies",
  "legal.cookies.sec1": "1. Que sont les cookies",
  "legal.cookies.sec1p": "Les cookies sont de petits fichiers texte placés sur votre appareil lorsque vous visitez un site web. Ils aident le site à reconnaître votre appareil et à stocker des informations sur vos préférences ou actions passées.",
  "legal.cookies.sec2": "2. Comment nous utilisons les cookies",
  "legal.cookies.sec2p": "L+TV TÉLÉVISION utilise des cookies pour améliorer votre expérience de navigation, analyser le trafic du site et comprendre comment les visiteurs interagissent avec notre site. Nous pouvons utiliser des cookies de session et des cookies persistants.",
  "legal.cookies.sec3": "3. Types de cookies que nous utilisons",
  "legal.cookies.sec3p": "Les cookies essentiels sont nécessaires au bon fonctionnement du site. Les cookies analytiques nous aident à comprendre comment les visiteurs interagissent avec notre site. Les cookies fonctionnels permettent des fonctionnalités améliorées et la personnalisation.",
  "legal.cookies.sec4": "4. Gestion des cookies",
  "legal.cookies.sec4p": "Vous pouvez gérer ou désactiver les cookies via les paramètres de votre navigateur. Notez que la désactivation de certains cookies peut affecter le fonctionnement de ce site.",
  "legal.cookies.sec5": "5. Contact",
  "legal.cookies.sec5p": "Si vous avez des questions sur notre politique de cookies, contactez-nous à L+TV TÉLÉVISION, B.P. : EDEA - Cameroun.",

  "legal.disclaimer.title": "Avertissement",
  "legal.disclaimer.sec1": "1. Exactitude des informations",
  "legal.disclaimer.sec1p": "L+TV TÉLÉVISION met tout en œuvre pour garantir que les informations de ce site web sont exactes et à jour. Cependant, nous ne garantissons pas l'exhaustivité, l'exactitude ou la fiabilité des informations fournies.",
  "legal.disclaimer.sec2": "2. Liens externes",
  "legal.disclaimer.sec2p": "Ce site web peut contenir des liens vers des sites web externes. L+TV TÉLÉVISION n'est pas responsable du contenu, de l'exactitude ou des pratiques des sites liés.",
  "legal.disclaimer.sec3": "3. Utilisation du contenu",
  "legal.disclaimer.sec3p": "Le contenu de ce site web est fourni à titre informatif uniquement. Il ne doit pas être interprété comme un conseil professionnel. Les utilisateurs doivent vérifier les informations de manière indépendante avant de prendre des décisions basées sur le contenu du site.",
  "legal.disclaimer.sec4": "4. Modifications du contenu",
  "legal.disclaimer.sec4p": "L+TV TÉLÉVISION se réserve le droit de modifier, mettre à jour ou supprimer le contenu de ce site web à tout moment sans préavis.",
  "legal.disclaimer.sec5": "5. Contact",
  "legal.disclaimer.sec5p": "Pour toute question concernant cet avertissement, contactez L+TV TÉLÉVISION, B.P. : EDEA - Cameroun.",

  // ---- Videos listing ----
  "videos.title": "Centre vidéo L+TV",
  "videos.subtitle": "Regardez les actualités, émissions, reportages et contenus exclusifs",
  "videos.searchPlaceholder": "Rechercher des vidéos...",
  "videos.noResults": "Aucune vidéo ne correspond à vos critères.",
  "videos.cat.all": "Toutes",
  "videos.cat.news": "Actualités",
  "videos.cat.interviews": "Interviews",
  "videos.cat.reports": "Reportages",
  "videos.cat.talkshows": "Talk-shows",
  "videos.cat.entertainment": "Divertissement",
  "videos.cat.culture": "Culture",
  "videos.cat.religion": "Religion",
  "videos.cat.children": "Émissions jeunesse",
  "videos.cat.sports": "Sports",
  "videos.cat.documentaries": "Documentaires",
  "videos.cat.short": "Vidéos courtes",
  "videos.cat.behind": "Coulisses",

  // ---- Advertise ----
  "advertise.title": "Faites de la publicité avec L+TV",
  "advertise.subtitle": "Touchez votre audience via les plateformes télévisuelles et numériques de L+TV",
  "advertise.intro":
    "L+TV TÉLÉVISION offre une gamme d'opportunités publicitaires et promotionnelles pour les entreprises, organisations et marques cherchant à atteindre des audiences à travers le Cameroun et au-delà. Que vous recherchiez des publicités télévisées, des placements numériques ou des partenariats événementiels, nous pouvons vous aider à concevoir une campagne efficace.",
  "advertise.servicesTitle": "Services publicitaires",
  "advertise.svc.tv.title": "Publicité télévisée",
  "advertise.svc.tv.desc": "Atteignez des milliers de téléspectateurs à travers le Cameroun avec des publicités télévisées produites professionnellement et diffusées sur L+TV.",
  "advertise.svc.web.title": "Publicité sur le site web",
  "advertise.svc.web.desc": "Affichez votre marque sur la plateforme numérique de L+TV avec des bannières, du contenu sponsorisé et des annonces à la une.",
  "advertise.svc.program.title": "Émissions sponsorisées",
  "advertise.svc.program.desc": "Sponsorisez une émission ou une série spécifique et associez votre marque à un contenu de qualité qui résonne avec votre public cible.",
  "advertise.svc.content.title": "Contenu sponsorisé",
  "advertise.svc.content.desc": "Collaborez avec L+TV pour créer du contenu de marque qui informe et engage les téléspectateurs tout en promouvant vos produits ou services.",
  "advertise.svc.video.title": "Promotion vidéo",
  "advertise.svc.video.desc": "Faites apparaître vos vidéos promotionnelles, présentations de produits ou histoires de marque sur le centre vidéo et les réseaux sociaux de L+TV.",
  "advertise.svc.social.title": "Promotion sur les réseaux sociaux",
  "advertise.svc.social.desc": "Tirez parti de la présence de L+TV sur les réseaux sociaux pour amplifier le message de votre marque sur Facebook, YouTube, TikTok, Instagram et plus.",
  "advertise.svc.event.title": "Partenariats événementiels",
  "advertise.svc.event.desc": "Associez-vous à L+TV pour la couverture d'événements en direct, des productions co-brandées et des opportunités de diffusion spéciales.",
  "advertise.formTitle": "Demande publicitaire",
  "advertise.formDesc": "Parlez-nous de vos besoins publicitaires et nous vous répondrons avec des options et des disponibilités.",
  "advertise.receivedTitle": "Demande reçue !",
  "advertise.receivedDesc": "Notre équipe publicitaire vous contactera prochainement avec des options et des tarifs.",
  "advertise.fullName": "Nom complet",
  "advertise.email": "E-mail",
  "advertise.company": "Entreprise / Organisation",
  "advertise.phone": "Téléphone",
  "advertise.service": "Service souhaité",
  "advertise.selectService": "Sélectionnez un service",
  "advertise.message": "Message",
  "advertise.messagePlaceholder": "Parlez-nous de vos besoins de campagne...",
  "advertise.submit": "Envoyer la demande",

  // ---- Direct ----
  "direct.title": "L+TV Direct",
  "direct.subtitle": "Campagnes numériques en direct, contenu interactif et engagement communautaire",
  "direct.intro":
    "L+TV Direct est une plateforme de campagne numérique spéciale où nous vous apportons des diffusions en direct, des discussions communautaires, des interviews et des événements spéciaux. Participez, posez vos questions et interagissez avec les présentateurs en temps réel.",
  "direct.tab.all": "Tous",
  "direct.tab.live": "En direct",
  "direct.tab.upcoming": "À venir",
  "direct.tab.ended": "Terminés",
  "direct.liveNow": "EN DIRECT",
  "direct.joinLive": "Rejoindre le direct",
  "direct.noSessions": "Aucune session trouvée dans cette catégorie.",

  // ---- Videos detail ----
  "video.notFound": "Vidéo introuvable",
  "video.backToVideos": "Retour aux vidéos",
  "video.relatedVideos": "Vidéos associées",
  "video.views": "vues",
  "video.share": "Partager",

  // ---- Live ----
  "live.liveTelevision": "Télévision en direct",
  "live.title": "L+TV EN DIRECT",
  "live.subtitle": "Regardez L+TV TÉLÉVISION en direct depuis Edea, Cameroun",
  "live.offlineTitle": "L+TV est actuellement hors ligne",
  "live.nextBroadcast": "Prochaine diffusion",
  "live.nowPlaying": "En ce moment",
  "live.upNext": "À suivre",
  "live.todaySchedule": "Programme du jour",
  "live.fullSchedule": "Grille complète",

  // ---- Search ----
  "search.placeholder": "Rechercher actualités, émissions, vidéos…",
  "search.noResults": "Aucun résultat trouvé.",
  "search.news": "Actualités",
  "search.programs": "Émissions",
  "search.videos": "Vidéos",
  "search.viewAll": "Voir tous les résultats",

  // ---- Shared ----
  "common.back": "Retour",
  "common.readMore": "Lire la suite",
  "common.viewAll": "Voir tout",
};

export default pages;